import { useState } from 'react';
import { generateECDHKeyPair, decryptEnvelope } from '../crypto/pairing-client';
import { joinPairing, fetchPairingResult } from '../api/pairing-api';

export function JoinRoomPage() {
  const [code, setCode] = useState('');
  const [status, setStatus] = useState<'idle' | 'joining' | 'waiting' | 'done' | 'error'>('idle');
  const [error, setError] = useState<string | null>(null);

  async function handleJoin() {
    if (code.length !== 6) {
      setError('配对码必须是 6 位字符');
      return;
    }
    setStatus('joining');
    setError(null);
    try {
      const { publicKey, privateKey } = await generateECDHKeyPair();
      await joinPairing(code, publicKey);
      setStatus('waiting');
      const pollInterval = setInterval(async () => {
        try {
          const result = await fetchPairingResult(code);
          if (result.envelope) {
            clearInterval(pollInterval);
            const creds = await decryptEnvelope(privateKey, result.envelope);
            sessionStorage.setItem('crossclip-room-creds', JSON.stringify(creds));
            sessionStorage.removeItem('crossclip-is-host');
            const url = `${window.location.origin}/r/${result.roomId}#k=${encodeURIComponent(creds.roomSecret)}&a=${encodeURIComponent(creds.accessToken)}`;
            window.location.href = url;
            setStatus('done');
          }
        } catch {
          // Not ready yet; keep polling.
        }
      }, 2000);
      setTimeout(() => clearInterval(pollInterval), 120000);
    } catch (err) {
      setError(err instanceof Error ? err.message : '加入失败');
      setStatus('error');
    }
  }

  return (
    <div>
      <div className="card" style={{ textAlign: 'center', marginTop: '3rem' }}>
        <h1>加入房间</h1>
        <p className="muted">输入 6 位配对码加入已创建的房间</p>
        <div style={{ display: 'flex', justifyContent: 'center', margin: '1.5rem 0' }}>
          <input
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            maxLength={6}
            placeholder="ABCDEF"
            aria-label="配对码"
            style={{ width: '10em' }}
            autoFocus
          />
        </div>
        <div className="stack" style={{ alignItems: 'center' }}>
          <button
            onClick={handleJoin}
            disabled={code.length !== 6 || status === 'joining' || status === 'waiting'}
            style={{ minWidth: '180px' }}
          >
            {status === 'joining' ? '加入中…' : status === 'waiting' ? '等待批准…' : '加入'}
          </button>
        </div>
        {status === 'waiting' && (
          <p className="muted" style={{ marginTop: '1rem' }}>
            请在房间的另一台设备上批准此加入请求（自动批准中）
          </p>
        )}
        {error && <p role="alert" style={{ marginTop: '1rem' }}>{error}</p>}
        <a href="/" className="muted" style={{ display: 'inline-block', marginTop: '1.5rem' }}>← 返回首页</a>
      </div>
    </div>
  );
}
